/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetWebTomarkdownAsyncStatusRequest = { task_id: string };

export const GetWebTomarkdownAsyncStatusRequest$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatusRequest
> = z.object({
  task_id: z.string().describe("任务ID（由提交接口返回）"),
});

/**
 * 任务不存在或已过期
 */
export type GetWebTomarkdownAsyncStatusNotFoundResponseBody = {
  error?: string | undefined;
  message?: string | undefined;
  code?: number | undefined;
};

export const GetWebTomarkdownAsyncStatusNotFoundResponseBody$zodSchema:
  z.ZodType<GetWebTomarkdownAsyncStatusNotFoundResponseBody> = z.object({
    code: z.int().optional(),
    error: z.string().optional(),
    message: z.string().optional(),
  }).describe("任务不存在或已过期");

export type GetWebTomarkdownAsyncStatus4 = {
  task_id?: string | undefined;
  status?: string | undefined;
  url?: string | undefined;
  progress?: number | undefined;
  created_at?: string | undefined;
  started_at?: string | undefined;
  completed_at?: string | undefined;
  duration?: number | undefined;
  error?: string | undefined;
};

export const GetWebTomarkdownAsyncStatus4$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatus4
> = z.object({
  completed_at: z.string().optional(),
  created_at: z.string().optional(),
  duration: z.number().optional(),
  error: z.string().optional(),
  progress: z.int().optional(),
  started_at: z.string().optional(),
  status: z.string().optional(),
  task_id: z.string().optional(),
  url: z.string().optional(),
});

export type GetWebTomarkdownAsyncStatusResult = {
  markdown?: string | undefined;
  size?: number | undefined;
};

export const GetWebTomarkdownAsyncStatusResult$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatusResult
> = z.object({
  markdown: z.string().optional(),
  size: z.int().optional(),
});

export type GetWebTomarkdownAsyncStatus3 = {
  task_id?: string | undefined;
  status?: string | undefined;
  url?: string | undefined;
  progress?: number | undefined;
  created_at?: string | undefined;
  started_at?: string | undefined;
  completed_at?: string | undefined;
  duration?: number | undefined;
  result?: GetWebTomarkdownAsyncStatusResult | undefined;
};

export const GetWebTomarkdownAsyncStatus3$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatus3
> = z.object({
  completed_at: z.string().optional(),
  created_at: z.string().optional(),
  duration: z.number().optional(),
  progress: z.int().optional(),
  result: z.lazy(() => GetWebTomarkdownAsyncStatusResult$zodSchema).optional(),
  started_at: z.string().optional(),
  status: z.string().optional(),
  task_id: z.string().optional(),
  url: z.string().optional(),
});

export type GetWebTomarkdownAsyncStatus2 = {
  task_id?: string | undefined;
  status?: string | undefined;
  url?: string | undefined;
  progress?: number | undefined;
  created_at?: string | undefined;
  started_at?: string | undefined;
  elapsed?: number | undefined;
  message?: string | undefined;
};

export const GetWebTomarkdownAsyncStatus2$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatus2
> = z.object({
  created_at: z.string().optional(),
  elapsed: z.number().optional(),
  message: z.string().optional(),
  progress: z.int().optional(),
  started_at: z.string().optional(),
  status: z.string().optional(),
  task_id: z.string().optional(),
  url: z.string().optional(),
});

export type GetWebTomarkdownAsyncStatus1 = {
  task_id?: string | undefined;
  status?: string | undefined;
  url?: string | undefined;
  progress?: number | undefined;
  created_at?: string | undefined;
  message?: string | undefined;
};

export const GetWebTomarkdownAsyncStatus1$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatus1
> = z.object({
  created_at: z.string().optional(),
  message: z.string().optional(),
  progress: z.int().optional(),
  status: z.string().optional(),
  task_id: z.string().optional(),
  url: z.string().optional(),
});

/**
 * 成功获取任务状态（包含各种状态的响应）
 */
export type GetWebTomarkdownAsyncStatusResponseBody =
  | GetWebTomarkdownAsyncStatus1
  | GetWebTomarkdownAsyncStatus2
  | GetWebTomarkdownAsyncStatus3
  | GetWebTomarkdownAsyncStatus4;

export const GetWebTomarkdownAsyncStatusResponseBody$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatusResponseBody
> = z.union([
  z.lazy(() => GetWebTomarkdownAsyncStatus1$zodSchema),
  z.lazy(() => GetWebTomarkdownAsyncStatus2$zodSchema),
  z.lazy(() => GetWebTomarkdownAsyncStatus3$zodSchema),
  z.lazy(() => GetWebTomarkdownAsyncStatus4$zodSchema),
]).describe("成功获取任务状态（包含各种状态的响应）");

export type GetWebTomarkdownAsyncStatusResponse =
  | GetWebTomarkdownAsyncStatus1
  | GetWebTomarkdownAsyncStatus2
  | GetWebTomarkdownAsyncStatus3
  | GetWebTomarkdownAsyncStatus4
  | GetWebTomarkdownAsyncStatusNotFoundResponseBody;

export const GetWebTomarkdownAsyncStatusResponse$zodSchema: z.ZodType<
  GetWebTomarkdownAsyncStatusResponse
> = z.union([
  z.union([
    z.lazy(() => GetWebTomarkdownAsyncStatus1$zodSchema),
    z.lazy(() => GetWebTomarkdownAsyncStatus2$zodSchema),
    z.lazy(() => GetWebTomarkdownAsyncStatus3$zodSchema),
    z.lazy(() => GetWebTomarkdownAsyncStatus4$zodSchema),
  ]),
  z.lazy(() => GetWebTomarkdownAsyncStatusNotFoundResponseBody$zodSchema),
]);
